// 9fbef606107a605d69c0edbcd8029e5d
import isEmpty from 'lodash/isEmpty';
import { css } from 'styled-components';

const getOverrideColorStyle = (props, defaultColor) => {
  return !isEmpty(props.brandThemeColor) ? props.brandThemeColor.color : defaultColor;
};

export default css`
  &.nav-bar-l1-promo-badge {
    padding: 7px 25px;
    border-radius: ${(props) => props.theme.brandSpecificStyles.PROMO_BADGE_BORDER_RADIUS};
    background-color: ${(props) =>
      getOverrideColorStyle(props, props.theme.brandSpecificStyles.PROMO_BADGE_BACKGROUND_COLOR)};
  }
`;
